(function(app) {

    app.directive("figProfilePicSrc",
    [
        "personApi", function(personApi) {
            return {
                scope: {
                    personId: "<figProfilePicSrc",
                    defaultSrc: "@?"
                },
                link: function(scope, elem, attrs) {
                    scope.$watch("personId", updateSrc);
                    var lastObjUrl;

                    scope.$on("$destroy",
                        function() {
                            if (lastObjUrl)
                                URL.revokeObjectURL(lastObjUrl);
                        });

                    function updateSrc(personId) {
                        if (!personId) return;

                        personApi.getProfilePicture(personId).then(function(response) {
                            var url = URL.createObjectURL(response);
                            elem[0].src = url;

                            if (lastObjUrl)
                                URL.revokeObjectURL(lastObjUrl);
                            lastObjUrl = url;
                        }, function () {
                            if (!!attrs.defaultSrc) {
                                elem[0].src = attrs.defaultSrc;
                                elem.addClass("no-picture");    
                            }
                        });
                    }

                }
            }
        }
    ]);

})(window.app); //jshint ignore:line